import React, {useState} from "react";
import { Container, Header, SpaceBetween } from "@amzn/awsui-components-react";
import AdjustmentsModal from "../common/adjustment/AdjustmentModal";
import QuickSightFrame from "../common/QuickSightFrame";

export default function ViewSummaryBreakdown(props) {
    const { exceptionData, useCase} = props;

    const [showAdjustmentModal, setShowAdjustmentModal] = useState(false);

    const adjustmentModalDismissHandler = () => {
        setShowAdjustmentModal(false);
    };

    return (
        <SpaceBetween>
            <Container header={<Header>BAS Summary</Header>}>
                <QuickSightFrame
                    exceptionData={exceptionData}
                    useCase={useCase}
                    linkKey='BAS_SUMMARY'/>
            </Container>
            <AdjustmentsModal
                showAdjustmentModal={showAdjustmentModal}
                onDismiss={adjustmentModalDismissHandler}
            />
        </SpaceBetween>
    );
}